import { makeStyles, Theme } from '@material-ui/core'
import { StyledAvatarProps } from './AvatarProps'
import { LoadingStatus } from './util/useImageProps'

const getAvatarDimensions = (theme: Theme, props: StyledAvatarProps) => {
  const factors = {
    'extra-small': 3,
    small: 4,
    medium: 5,
    large: 6,
    'extra-large': 12.5,
  }
  const sizeFactor = factors[props.size || 'medium']
  return theme.spacing(sizeFactor)
}

const getAvatarFontSize = (props: StyledAvatarProps) => {
  const fontSizes = {
    'extra-small': '0.75rem',
    small: '1rem',
    medium: '1rem',
    large: '1.25rem',
    'extra-large': '3.5rem',
  }
  return fontSizes[props.size]
}

export const useAvatarStyles = makeStyles<Theme, StyledAvatarProps>((theme) => ({
  root: (props) => ({
    width: getAvatarDimensions(theme, props),
    height: getAvatarDimensions(theme, props),
    fontSize: getAvatarFontSize(props),
    backgroundColor: props.loaded === LoadingStatus.LOADED ? 'transparent' : props.background,
    color: theme.palette.getContrastText(props.background),
    objectFit: props.fit,
  }),
  fallback: (props) => ({
    fontSize: getAvatarDimensions(theme, props),
    strokeWidth: 1,
  }),
}))
